import {JsonProperty} from '@hyperloris/tyson';
import {User} from "./user";
import {CCRolesType} from "./cc-roles-type";


export class UserGroup {

  @JsonProperty()
  groupName: string | undefined;

  @JsonProperty()
  originGroupName: string | undefined;

  @JsonProperty()
  enabled: boolean = false;

  @JsonProperty()
  usernames: string[] | undefined;

  @JsonProperty({type: [CCRolesType.Roles]})
  roles: CCRolesType.Roles[] | undefined;

}
